import React from "react";

export const StarcountLogo = () => (
  <svg viewBox="0 0 264.5 56.8">
    <g fill="#FFFFFF">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  className="st0"
                  d="M11.8,44l1.7-1.3c1.5,2.2,3.3,3.3,5.4,3.3c1.2,0,2.1-0.3,2.8-0.9c0.7-0.6,1.1-1.4,1.1-2.4
c0-0.8-0.2-1.4-0.7-1.9c-0.5-0.4-1.3-0.9-2.5-1.5l-2.2-1c-1.5-0.7-2.6-1.4-3.3-2.2c-0.7-0.8-1.1-1.8-1.1-3
c0-1.5,0.6-2.7,1.7-3.7c1.1-0.9,2.5-1.4,4.2-1.4c1.3,0,2.4,0.3,3.5,0.9c1.1,0.6,1.9,1.4,2.6,2.4l-1.7,1.3
c-1.1-1.6-2.6-2.4-4.4-2.4c-1,0-1.8,0.3-2.5,0.8c-0.7,0.5-1,1.2-1,2.1c0,0.6,0.1,1,0.4,1.4c0.2,0.4,0.5,0.6,0.9,0.9
s1,0.6,1.8,1l2.1,1c1.6,0.8,2.7,1.6,3.5,2.4c0.7,0.8,1.1,1.8,1.1,3c0,1.6-0.6,2.9-1.8,3.9c-1.2,1-2.7,1.5-4.5,1.5
c-1.5,0-2.9-0.4-4.1-1.1C13.5,46.3,12.5,45.3,11.8,44z"
                />
                <path
                  className="st0"
                  d="M43.2,47.8V30.4h-6.8v-2.1h16v2.1h-6.9v17.4H43.2z"
                />
                <path
                  className="st0"
                  d="M75.7,47.8l-1.6-3.9h-9.5l-1.6,3.9h-2.4l8.4-19.8h0.9l8.4,19.8H75.7z M73.2,41.8l-3.9-9.6l-3.9,9.6H73.2z"
                />
                <path
                  className="st0"
                  d="M105.7,47.8h-2.7l-6-8.2h-4.1v8.2h-2.3V28.4h6.8c1.9,0,3.4,0.5,4.5,1.6c1.1,1.1,1.7,2.4,1.7,4
c0,1.3-0.4,2.4-1.1,3.4c-0.7,1-1.7,1.6-3,2L105.7,47.8z M92.9,30.4v7.2h4.4c1.2,0,2.2-0.3,2.9-1c0.7-0.6,1-1.5,1-2.6
c0-1.1-0.4-1.9-1-2.6c-0.7-0.7-1.7-1-2.9-1H92.9z"
                />
                <path
                  className="st0"
                  d="M116.2,38.1c0-2.8,1-5.2,3-7.2c2.1-2,4.5-3,7.3-2.9c1.8,0,3.5,0.4,5,1.3c1.5,0.9,2.7,2,3.5,3.5l-3,2.1
c-1.4-2.2-3.2-3.3-5.6-3.3c-1.8,0-3.3,0.6-4.5,1.8c-1.2,1.2-1.8,2.7-1.8,4.6c0,1.8,0.6,3.4,1.8,4.6c1.2,1.2,2.7,1.8,4.5,1.8
c2.3,0,4.2-1.1,5.6-3.3l3,2.1c-0.8,1.5-2,2.7-3.5,3.5c-1.5,0.9-3.2,1.3-5.1,1.3c-2.8,0.1-5.3-0.9-7.3-2.9
C117.1,43.3,116.1,40.9,116.2,38.1z"
                />
                <path
                  className="st0"
                  d="M146,38.1c0-2.8,1-5.2,3-7.2c2-2,4.5-3,7.3-2.9c2.8-0.1,5.2,0.9,7.3,2.9c2.1,2,3.1,4.4,3,7.2
c0,2.8-1,5.2-3,7.2c-2.1,2-4.5,3-7.3,2.9c-2.8,0.1-5.2-0.9-7.3-2.9C147,43.2,146,40.9,146,38.1z M162.6,38.1
c0-1.8-0.6-3.4-1.8-4.6c-1.2-1.2-2.7-1.8-4.5-1.8c-1.8,0-3.3,0.6-4.5,1.8c-1.2,1.2-1.8,2.7-1.8,4.6s0.6,3.4,1.8,4.6
c1.2,1.2,2.7,1.8,4.5,1.8c1.8,0,3.3-0.6,4.5-1.8C162,41.5,162.6,40,162.6,38.1z"
                />
                <path
                  className="st0"
                  d="M178.7,39.8V28.4h4v11.7c0,1.4,0.4,2.5,1.2,3.3c0.8,0.8,1.8,1.2,3.1,1.2c1.3,0,2.3-0.4,3.1-1.2
c0.8-0.8,1.2-1.9,1.2-3.3V28.4h4v11.4c0,2.5-0.8,4.6-2.3,6.1c-1.5,1.5-3.5,2.3-5.9,2.3c-2.4,0-4.4-0.8-5.9-2.3
C179.5,44.3,178.7,42.3,178.7,39.8z"
                />
                <path
                  className="st0"
                  d="M220.9,28.4h4v19.8h-1.3l-11.2-12v11.7h-4V28h1.3l11.3,12V28.4z"
                />
                <path
                  className="st0"
                  d="M242.6,47.8V32h-6.2v-3.6h16.4V32h-6.2v15.8H242.6z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  className="st0"
                  d="M244.1,18.6c0,0-24.4-10.4-59.7-10c-45,0.6-66.6,13.2-66.6,13.2s30.8-13,74.2-11.1
c38,1.6,51.5,8.9,51.5,8.9L244.1,18.6z"
                />
              </g>
              <g>
                <circle className="st0" cx="244" cy="19.4" r="2.9" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
